"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTypography = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var Title = antd_1.Typography.Title, Paragraph = antd_1.Typography.Paragraph, Text = antd_1.Typography.Text;
var tailwindColorMap = {
    default: '!text-gray-800',
    primary: '!text-primary',
    secondary: '!text-gray-500',
    success: '!text-green-600',
    warning: '!text-yellow-600',
    danger: '!text-red-600',
    white: '!text-white',
};
var ACTypography = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'p' : _b, label = _a.label, _c = _a.color, color = _c === void 0 ? 'default' : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    var colorClass = tailwindColorMap[color] || tailwindColorMap.default;
    var combinedClassName = "".concat(colorClass, " ").concat(className).trim();
    if (type.startsWith('h')) {
        var level = parseInt(type === null || type === void 0 ? void 0 : type[1], 10) || 1;
        return ((0, jsx_runtime_1.jsx)(Title, { level: level, style: {
                margin: 0,
            }, className: combinedClassName, children: label }));
    }
    if (type === 'p') {
        return ((0, jsx_runtime_1.jsx)(Paragraph, { style: {
                margin: 0,
                fontWeight: 500,
            }, className: combinedClassName, children: label }));
    }
    return ((0, jsx_runtime_1.jsx)(Text, { style: {
            margin: 0,
            fontSize: '12px',
        }, className: combinedClassName, children: label }));
};
exports.ACTypography = ACTypography;
